export default "__VITE_ASSET__CRSKnYtT__"